import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
interface EyebrowProps {
  children: React.ReactNode;
  className?: string;
}
export function Eyebrow(t0) {
  const $ = _c(8);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center gap-2 text-text-secondary", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div data-slot="solid-shape" className="relative aspect-square size-3 overflow-hidden"><svg className="absolute inset-0 h-full w-full" viewBox="0 0 240 240" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><path d="M224 16C191.195 81.4502 191.195 158.55 224 224C158.55 191.195 81.4503 191.195 16 224C48.8055 158.55 48.8055 81.4502 16 16C81.4503 48.8055 158.55 48.8055 224 16Z" fill="#B8DBF7" /></svg></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <span data-slot="overline" className="typography-mobile-heading-overline desktop:typography-desktop-heading-overline">{children}</span>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}